<div class="conteneur" *ngIf="userData; else loader">
  <div class="fx-direction-row fx-wrap">

    <mat-card appearance="raised" class="card login">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <mat-icon>account_circle</mat-icon>
          Informations de connexion
        </mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="row items-center" style="margin-top: 5px;" *ngIf="user.fromOIDC && !!oidcProvider">
          <img [src]="oidcProvider?.providerLogo" class="oidc-logo" [title]="'Logo : '+oidcProvider.providerName" />
          <span> Vous êtes identifié grâce à {{oidcProvider.providerName}} </span>
        </div>
        <div class="btn-group" *ngIf="user.fromOIDC">
          <button mat-raised-button color="primary" routerLink="/logout">
            <mat-icon>exit_to_app </mat-icon>
            Se déconnecter
          </button>
        </div>


        <div class="row items-center" style="margin-top: 5px;">
          <mat-icon class="email-icon" matTooltip="Adresse email">alternate_email</mat-icon>
          <span>{{ userData.email }}</span>
        </div>

        <div class="btn-group">
          <button mat-raised-button color="primary" (click)="onClickChangeEmail()" [disabled]="!user">
            <mat-icon>email</mat-icon>
            Modifier mon adresse email
          </button>

          <button mat-raised-button color="primary" routerLink="/account/update-password" *ngIf="!user.fromOIDC">
            <mat-icon>password</mat-icon>
            Modifier mon mot de passe
          </button>

          <button mat-raised-button color="primary" routerLink="/account/totp-manage"
            *ngIf="authConfig.doubleAuth.isActive">
            <mat-icon>admin_panel_settings</mat-icon>
            {{(user.totpEnrolled ? 'totp.access_button_when_active' : 'totp.access_button_when_inactive') |trans }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card appearance="raised" class="card" *ngFor="let step of adulteFormSteps">
      <mat-card-header class="card-header fx-direction-row fx-between-center">
        <mat-card-title class="fx-direction-row fx-start-center">
          <mat-icon *ngIf="step.stepName === 'coordinates'">contacts</mat-icon>
          <mat-icon *ngIf="step.stepName === 'personal'">assignment_ind</mat-icon>
          <mat-icon *ngIf="step.stepName === 'professional'">business_center</mat-icon>
          <mat-icon *ngIf="step.stepName === 'complement'">assignment</mat-icon>
          <span>{{ step.label }}</span>
        </mat-card-title>
        <button mat-mini-fab color="primary" [matTooltip]="editable ? 'Voir/Modifier' : 'Voir'"
          routerLink="/account/user/{{step.stepName}}">
          <mat-icon *ngIf="editable">edit</mat-icon>
          <mat-icon *ngIf="!editable">visibility</mat-icon>
        </button>
      </mat-card-header>
      <mat-card-content style="flex: 1">
        <ng-container *ngIf="step.stepName === 'coordinates'" [ngTemplateOutlet]="coordinates"></ng-container>
        <ng-container *ngIf="step.stepName === 'personal'" [ngTemplateOutlet]="personal"></ng-container>
        <ng-container *ngIf="step.stepName === 'professional'" [ngTemplateOutlet]="professional"></ng-container>
        <ng-container *ngIf="step.stepName === 'complement'" [ngTemplateOutlet]="complement"></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #coordinates>

  <div class="info-grid">
    <div class="info-item">
      <span class="info-label">Nom prénom</span>
      <span class="info-value">
        {{ userData.civilite }} {{ userData.nom | uppercase }} {{
        userData.prenom }}
      </span>
    </div>

    <div class="info-item">
      <span class="info-label">Adresse</span>
      <span class="info-value">
        {{ userData.numRue }} {{ userData.rue }}
        <span *ngIf="userData.rue2"><br>{{ userData.rue2 }}</span>
        <span *ngIf="userData.rue3"><br>{{ userData.rue3 }}</span>
        <br>{{ userData.codePostal }} {{ userData.ville }}
      </span>
    </div>

    <div class="info-item">
      <span class="info-label">Contact</span>
      <div class="info-value">
        @if (userData.telephone) {
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>local_phone</mat-icon>
          {{ userData.telephone }}
        </div>
        }
        @if (userData.telMobile) {
        <div class="info-line fx-direction-row fx-start-center">
          <mat-icon>phone_android</mat-icon>
          {{ userData.telMobile }}
        </div>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #personal>
  <div style="height: 100%;" class="fx-direction-col fx-justify-content-between">
    <div class="info-grid">
      <div class="info-item" *ngIf="userData.situationFamiliale && listKeysFieldForm.includes('situationFamiliale')">
        <span class="info-label">Situation familiale</span>
        <span class="info-value">{{ userData.situationFamilialeName }}</span>
      </div>
      @if(userData.dateNaissance && listKeysFieldForm.includes('dateNaissance')){
      <div class="info-item">
        <span class="info-label">Date de naissance</span>
        <span class="info-value">{{ userData.dateNaissance | date:'shortDate' }}</span>
      </div>
      }
      <div class="info-item" *ngIf="userData.sexe && listKeysFieldForm.includes('sexe')">
        <span class="info-label">Sexe</span>
        <span class="info-value">{{userData.sexe === "F" ? 'Féminin' : 'Masculin'}}</span>
      </div>
    </div>
    <div class="fx-direction-row fx-center-center" style="margin-top: 5px;">
      <mat-icon class="more-horiz">more_horiz</mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #professional>
  <div style="height: 100%;" class="fx-direction-col fx-justify-content-between">
    <div class="info-grid">
      @if(userData.profession && listKeysFieldForm.includes('profession')){
      <div class="info-item">
        <span class="info-label">Profession</span>
        <span class="info-value">{{ userData.profession }}</span>
      </div>
      }
      @if(userData.lieuTravail && listKeysFieldForm.includes('lieuTravail')){
      <div class="info-item">
        <span class="info-label">Lieu de travail</span>
        <span class="info-value">
          {{ userData.lieuTravail }}
          @if(userData.rueTravail && listKeysFieldForm.includes('rueTravail')){
          <span><br>{{ userData.rueTravail }}</span>
          }
          @if(userData.codePostalTravail && listKeysFieldForm.includes('codePostalTravail')){
          <span><br>{{userData.codePostalTravail }}</span>
          }
          @if(userData.villeTravail && listKeysFieldForm.includes('villeTravail')){
          {{userData.villeTravail}}
          }
        </span>
      </div>
      }
    </div>
    <div class="fx-direction-row fx-center-center" style="margin-top: 5px;">
      <mat-icon class="more-horiz">more_horiz</mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #complement>
  <div class="fx-direction-row fx-center-center" style="margin-top: 5px;">
    <mat-icon class="more-horiz">more_horiz</mat-icon>
  </div>
</ng-template>

<ng-template #updateEmailDialog>
  <app-user-update-email [user]="user" [inDialog]="true" (done)="closeUpdateEmailDialog()"
    (cancel)="closeUpdateEmailDialog()"></app-user-update-email>
</ng-template>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>